import React from "react";

export function focusHasLeftElement<
  CurrentTarget extends Element,
  RelatedTarget extends Element
>(e: React.FocusEvent<CurrentTarget, RelatedTarget>): boolean {
  if (!e.relatedTarget) return false;
  return !e.currentTarget.contains(e.relatedTarget);
}
